define('views/pages/user/password',['require','underscore','mediator','views/base/form','views/base/modal','models/base/modal','text!templates/pages/user/password.ejs','views/demo-dialog'],function(require) {
    'use strict';

    var _ = require('underscore'),
        mediator = require('mediator'),
        FormView = require('views/base/form'),
        ModalView = require('views/base/modal'),
        ModalModel = require('models/base/modal'),
        template = require('text!templates/pages/user/password.ejs'),
        DemoDialog = require('views/demo-dialog');

    // USER PASSWORD

    var UserPasswordPageView = FormView.extend({
        autoRender: true,
        template: template,
        className: 'page',
        id: 'pages-user-password-page',
        region: 'main',
        listen: {
            'change:loading model': 'updateBreadcrumb'
        },
        initialize: function() {
            FormView.prototype.initialize.apply(this, arguments);
            var _this = this;
            this.model.on('afterLoad', function() {
                _this.render();
            });
        },
        save: function(){
            if (DemoDialog.isDemo()) { return this.render() && DemoDialog.show(); }

            var _this = this,
            currentPassword = this.model.get('currentPassword'),
            newPassword = this.model.get('newPassword'),
            confirmPassword = this.model.get('confirmPassword');

            var errors = {};
            if(!currentPassword){
                errors.currentPassword = 'Введите пароль';
            }

            if(!newPassword){
                errors.newPassword = 'Введите новый пароль';
            } else if (newPassword.length < 6) {
                errors.newPassword = 'Пароль должен содержать минимум 6 символов';
            }

            if(confirmPassword !== newPassword){ errors.confirmPassword = 'Пароли не совпадают'; }

            if(_.isEmpty(errors)){
                if(this.model.get('ID') !== 0 ){
                    this.model.save().complete(function(response) {
                        if(response.status === 200){
                            var messages = response.responseJSON.messages;
                            if(messages){
                                if (messages.global) {
                                    _this.errorMessages = [];
                                    _this.errorMessages.push('Ошибка при сохранении');
                                } else {
                                    _this.model.set('errors', messages);
                                }
                            } else {
                                _this.errorMessages = [];
                                _this.model.set('errors', {});
                                _this.model.set('currentPassword', '');
                                _this.model.set('newPassword', '');
                                _this.model.set('confirmPassword', '');
                                _this.showOkDialog();
                            }
                        } else {
                            _this.errorMessages = [];
                            _this.errorMessages.push('Ошибка при сохранении');
                        }
                       _this.render();
                    });
                }
            } else {
                this.model.set('errors', errors);
                this.render();
            }
        },
        showOkDialog: function(){
            var modalModel = new ModalModel({
                'title': 'Информация',
                'buttons': [
                    { caption: 'Закрыть', className: '', 'action': 'cancel' }
                ],
                body: '<h4>Пароль изменен успешно.</h4>',
                errors: {}
            });
            var okDialog = new ModalView({ model: modalModel });
            this.subview('modal', okDialog);
        },
        updateBreadcrumb: function() {
            var org = {
                name: 'organization',
                action: 'organization#show',
                params: { page: 'settings'},
                title: 'Компания'
            },
            orgUsers = {
                name: 'organization',
                action: 'organization#show',
                params: { page: 'users'},
                title: 'Сотрудники'
            };
            mediator.setBreadcrumb([org, orgUsers, 'user'], 'Изменение пароля');
        }
    });

    return UserPasswordPageView;
});
